import { eventService } from '@/services/eventService';
import { useEventStore } from '@/stores/event';

export function useEventFavorite() {
    function isEventProcessing(eventId: string): boolean {
        const store = useEventStore();
        return eventId in store.favoriteEventProcessing;
    }

    function isEventFavorite(eventId: string): boolean {
        const store = useEventStore();
        return eventId in store.favoriteEvent;
    }

    function toggleEventFavorite(eventId: string): void {
        if (isEventProcessing(eventId)) {
            return;
        }

        if (isEventFavorite(eventId)) {
            void eventService.removeFavorite(eventId);
        } else {
            void eventService.addFavorite(eventId);
        }
    }

    return {
        isEventProcessing,
        isEventFavorite,
        toggleEventFavorite,
    };
}
